import { useEffect } from 'react';

export const useReloadPage = ({ shouldRedirect }) => {
    useEffect(() => {
        if (shouldRedirect) {
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }, [shouldRedirect]);
};
